import React from 'react';

function RemunerationSEO() {
  return <meta name="description" content="Beloningsbeleid Closure" />;
}

export default RemunerationSEO;
